import domain from './domain';

/*
 * Login endpoints list
 * */
const loginEndpointsConfig: string[] = [
  `${ domain.protocol }//${ domain.dealroadshowDomain }`,
  `${ domain.protocol }//${ domain.usersDomain }/login`,
  `${ domain.protocol }//${ domain.usersDomain }/login/condor`,
  `${ domain.protocol }//${ domain.condorDomain }/login/condor`,
];

export default loginEndpointsConfig;
